import { render, staticRenderFns } from "./MainHeader2.vue?vue&type=template&id=65e481b9&scoped=true&"
import script from "./MainHeader2.vue?vue&type=script&lang=js&"
export * from "./MainHeader2.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader2.vue?vue&type=style&index=0&id=65e481b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e481b9",
  null
  
)

export default component.exports